// Deterministic lith-code palette (seeded with known codes, supports new ones).

const SEEDED_CODES = [
  'NR',
  'GRD',
  'VOID',
  'GAO',
  'QTZ',
  'PBO',
  'GPG',
  'DIO',
  'TSO',
  'BCKF',
  'V',
  'APL',
  'AMP_CHL',
  'QTZ_HB_',
  'BI',
  'NA',
  'MOO',
  'BKF',
  'SER',
  'SOO',
  'IS',
  'CHL',
  'OFM',
  'PBH',
  'MAH',
  'FOO',
  'EP',
  'CHP',
  'HEM',
  'SIL',
  'F',
  'PS'
];

const COLOR_POOL = [
  0x1f77b4, 0xff7f0e, 0x2ca02c, 0xd62728, 0x9467bd, 0x8c564b, 0xe377c2, 0x7f7f7f,
  0xbcbd22, 0x17becf, 0x393b79, 0x637939, 0x8c6d31, 0x843c39, 0x7b4173, 0x3182bd,
  0xe6550d, 0x31a354, 0x756bb1, 0x636363, 0x6baed6, 0xfd8d3c, 0x74c476, 0x9e9ac8,
  0x969696, 0x9ecae1, 0xfdae6b, 0xa1d99b, 0xbcbddc, 0xbdbdbd, 0xc6dbef, 0xfdd0a2,
  0xc7e9c0, 0xdadaeb
];

const hashString = (value) => {
  let hash = 0;
  const str = String(value || '');
  for (let i = 0; i < str.length; i += 1) {
    hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
  }
  return hash;
};

const normalizeLithCode = (code) => String(code || '').trim().toUpperCase();

const assigned = new Map();
let nextIdx = 0;

SEEDED_CODES.forEach((code) => {
  const key = normalizeLithCode(code);
  if (!key || assigned.has(key)) return;
  assigned.set(key, COLOR_POOL[nextIdx % COLOR_POOL.length]);
  nextIdx += 1;
});

export function getLithColorHex(code) {
  const key = normalizeLithCode(code);
  if (!key) return 0x000000;
  if (assigned.has(key)) return assigned.get(key);

  const idx = hashString(key) % COLOR_POOL.length;
  const color = COLOR_POOL[idx];
  assigned.set(key, color);
  return color;
}

export function getLithLegendItems(codes) {
  const uniq = Array.from(
    new Set((codes || []).map(normalizeLithCode).filter(Boolean))
  ).sort((a, b) => a.localeCompare(b));

  return uniq.map((code) => ({ code, color: `#${getLithColorHex(code).toString(16).padStart(6, '0')}` }));
}
